import React from 'react';
import './TrustedBy.css';

const TrustedBy = () => {
  const clients = [
    {
      name: 'Denver Zoo Conservation Alliance',
      logo: 'https://denverzoo.org/wp-content/uploads/2024/06/FooterLogo.png',
      url: 'https://denverzoo.org'
    },
    {
      name: 'State Farm - Natalie Reid, Agent',
      logo: 'https://static.prod-images.emergentagent.com/jobs/18d5f296-1985-4248-97b7-ff15c2909e3a/images/948399976fcd94b241f46cefe4da146b4bef2593a68f3b7c29615cb4601e9836.png',
      url: 'https://insurewithnat.com'
    },
    {
      name: 'Park Street Homes',
      logo: 'https://static.prod-images.emergentagent.com/jobs/18d5f296-1985-4248-97b7-ff15c2909e3a/images/9bb62cc85fdefc79d9dc68139a9019d8b531f97ad720c4ea6fb8029ba0c3dae7.png',
      url: '#'
    },
    {
      name: 'Pulse Staffing',
      logo: 'https://static.prod-images.emergentagent.com/jobs/18d5f296-1985-4248-97b7-ff15c2909e3a/images/7adf980bfadb30b7133b95c69d8c64ff2393ca21e360c5af2b73eb3af261c56e.png',
      url: '#'
    },
    {
      name: 'Uptown Homecare',
      logo: 'https://static.prod-images.emergentagent.com/jobs/18d5f296-1985-4248-97b7-ff15c2909e3a/images/179ad8e35fe6cd4ae46134b555e5c880bc1493035ec1968afc41bb021485707d.png',
      url: '#'
    }
  ];

  const logoItems = clients.map((client, index) => (
    <a
      key={index}
      href={client.url}
      target="_blank"
      rel="noopener noreferrer"
      className="client-logo-wrapper"
      aria-label={client.name}
      data-testid={`client-logo-${index}`}
    >
      <img src={client.logo} alt={client.name} className="client-logo" />
    </a>
  ));

  return (
    <section className="trusted-by-section" data-testid="trusted-by-section">
      <div className="trusted-by-container">
        <p className="trusted-by-label" data-testid="trusted-by-label">Trusted By</p>
        <div className="marquee-wrapper" data-testid="trusted-by-logos">
          <div className="marquee-track">
            {logoItems}
            {clients.filter(c => c.name !== 'State Farm - Natalie Reid, Agent').map((client, i) => (
              <a
                key={`dup-${i}`}
                href={client.url}
                target="_blank"
                rel="noopener noreferrer"
                className="client-logo-wrapper"
                aria-hidden="true"
              >
                <img src={client.logo} alt={client.name} className="client-logo" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustedBy;
